import request from '@/utils/request'

/**
 * 用户登录
 * @param {Object} data 登录数据
 */
export function loginApi(data) {
  return request({
    url: '/user/auth/login',
    method: 'post',
    data,
  });
}

/**
 * 用户注册
 * @param {Object} data 注册数据
 */
export function registerApi(data) {
  return request({
    url: '/user/auth/register',
    method: 'post',
    data,
  });
}

/**
 * 发送验证码 type=login 登录，type=register 注册
 * @param {Object} params 邮箱参数
 */
export function sendVerifyCodeApi(params) {
  return request({
    url: '/user/auth/sendVerifyCode',
    method: 'get',
    params,
  });
}


/**
 * 更新用户头像
 * @param {Object} data 头像数据
 */
export function updateAvatarApi(data) {
  return request({
    url: '/user/auth/updateAvatar',
    method: 'post',
    data,
  });
}
